import Vue from 'vue'
import VueRouter from 'vue-router'
import Form from '@/views/Form.vue'
import { auth } from '@/firebase'

Vue.use(VueRouter)

const routes = [
  {
    path: '/form/:id',
    name: 'Form',
    component: Form
  },
  {
    path: '/login',
    name: 'Login',
    component: () => import('@/views/Login.vue')
  },
  {
    path: '/admin',
    name: 'Admin',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import('@/views/admin/Index.vue'),
    meta: { requiresAuth: true },
    // redirect: { name: 'Forms' },
    children: [
      {
        path: 'forms',
        name: 'FormsIndex',
        component: () => import('@/views/admin/forms/Index.vue'),
        children: [
          {
            name: 'Forms',
            path: '',
            component: () => import('@/views/admin/forms/Forms.vue'),
            meta: { requiresAuth: true }
          },
          {
            name: 'FormAdd',
            path: 'add',
            component: () => import('@/views/admin/forms/Edit.vue'),
            meta: { requiresAuth: true, isEdit: false }
          },
          {
            name: 'FormEdit',
            path: ':formId/edit',
            component: () => import('@/views/admin/forms/Edit.vue'),
            meta: { requiresAuth: true, isEdit: true }
          }
        ]
      },
      {
        path: 'dashboard',
        name: 'Dashboard',
        component: () => import('@/views/admin/Dashboard.vue'),
        meta: { requiresAuth: true }
      }
    ]
  }
]

const router = new VueRouter({
  routes
})

router.beforeEach((to, from, next) => {
  const requiresAuth = to.matched.some(route => route.meta.requiresAuth)
  const currentUser = auth.currentUser

  if (requiresAuth && !currentUser) next({ name: 'Login', query: { redirect: to.fullPath } })
  else if (!requiresAuth && currentUser) next('/admin')
  else if (!requiresAuth && !currentUser) next()
  else next()
})

export default router
